/**
 * 通知 - コンポーネント
 * @see       ABUI_doc__Component_Alert.html
 * @namespace '.alert'
 */

if($('.open-alert').length) {
  const display_timer = 3000;
  const alH = 56;
  const nbH = 48;
  const nlH = 64;
  $.showAlert = function(triggerEl) {
    /**
     * 非同期処理
     * @type {Object}
     */
    const deferred = $.Deferred();

    /**
     * トリガーとなる要素を取得
     * @type {String}
     */
    const an = '.' + $(triggerEl).attr('data-tgt');

    /**
     * animation中の場合data-status = '1'
     */
    if($(an).attr('data-status') === '0') {
      $(an).addClass('show-alert');
      if($(an).hasClass('alert-center')) {
        lockScreen('lock');
        $('.wrapper-page').addClass('showing-alert').addClass('disable');
        /**
         * アラートの横幅取得
         * @type {Number}
         */
        // const w = $(an).outerWidth();
        // $(an).css('margin-left', -w / 2);
      } else if($(an).hasClass('alert-top-fixed')) {
        const bg = '<div class="alert-top-fixed--bg"></div>'
        $('body').append(bg);
        $('.sidebar-fixed-top').css('top', alH);
        $('.sidebar-fixed-top-bs').css('top', alH + nbH);
        $('.sidebar-fixed-top-bslg').css('top', alH + nbH + nlH);
        $('.wrapper-page').css('padding-top', alH);
        $('.navbar-fixed-top').css('top', alH);
      }

      $(an).attr('data-status', 1);
      setTimeout(function() {
        if(!$(an).hasClass('alert-dismissible') && !$(an).hasClass('alert-top-fixed')) {
          if($(an).hasClass('alert-center')) {
            $('.wrapper-page').removeClass('disable');
          }
          $(an).addClass('hiding');
          $(an).bind('transitionend', function() {
            $(an).addClass('displaynone').removeClass('hiding');
            if($(an).hasClass('alert-center')) {
              $('.wrapper-page').removeClass('showing-alert');
            }
            $(an).removeClass('show-alert');
            setTimeout(function() {
              $(an).removeClass('displaynone');
              unLockScreen('lock');
              $('body').removeClass('disable-operation');
              $(an).unbind('transitionend');
              $(an).attr('data-status', 0);
              deferred.resolve();
            });
          });
        }
      }, display_timer);
      // return deferred.promise();
    } else {
      return false;
    }
    return deferred.promise();
  }

  /**
   * 通知の起動
   */
  $('.alert').attr('data-status', 0);
  $('.alert').find('a:not([data-hide="alert"])').off('.alert');
  $('.alert').find('a:not([data-hide="alert"])').on('click.alert', function() {
    if(!$(this).parents('.alert').hasClass('alert-top-fixed')) {
      $(this).parents('.alert').fadeOut('fast');
    };
  });

  /**
   * 中央に通知を表示：linkあり
   * @see 中央に表示する場合
   */
  if($('.alert-link').length) {
    $('.alert-link').off('.alert');
    $('.alert-link').on('click.alert', function() {
      $(this).parents('body').removeClass('disable-operation');
      unLockScreen('lock');
    });
  }

  /**
   * Notification要close
   */
  $('[data-hide]').off('.alert');
  $('[data-hide]').on('click.alert', function() {
    let an = $(this).closest('.' + $(this).attr('data-hide'));
    if($(an).hasClass('alert-center')) {
      $('.wrapper-page').removeClass('disable');
      $(an).bind('transitionend', function() {
        $('.wrapper-page').removeClass('showing-alert');
        $(an).unbind('transitionend');
      });
      $(an).addClass('displaynone').removeClass('show-alert');
    } else if($(an).hasClass('alert-top-fixed')) {
      // $(an).css('z-index', '1020');
      $('.alert-top-fixed--bg').css('z-index', '1010');
      $('.sidebar-fixed-top').animate({
        top: '0px'
      }, 300, 'swing');
      $('.sidebar-fixed-top-bs').animate({
        top: nbH
      }, 300, 'swing');
      $('.sidebar-fixed-top-bslg').animate({
        top: nbH + nlH
      }, 300, 'swing');
      $('.wrapper-page').animate({
        paddingTop: '0px'
      }, 300, 'swing');
      $('.navbar-fixed-top').animate({
        top: '0px'
      }, 300, 'swing');
      $('#header-site').css('z-index', '1040');
      $(an).addClass('displaynone').removeClass('show-alert');
    } else {
      $(an).addClass('displaynone').removeClass('show-alert');
    }
    setTimeout(function() {
      $(an).removeClass('displaynone');
      unLockScreen('lock');
      $('body').removeClass('disable-operation');
      $(an).unbind('transitionend');
      $(an).attr('data-status', 0);
      $('.alert-top-fixed--bg').remove();
      //リンククリックでaタグがdisplay: noneになる現象を回避（原因不明）
      // $('.alert-message').show();
    }, 300);
  });


  /**
   * 画面をロックする
   * @param  {String} id idに'lock'を付与
   */
  function lockScreen(id) {
    'use strict';
    const divTag = $('<div />').attr('id', id);
    divTag.css({
      'z-index':'9998',
      position:'fixed',
      top:'0',
      bottom:'0',
      left:'0',
      right:'0',
      overflow:'hidden'
    });
    $('body').append(divTag).addClass('disable-operation');
  }

  /**
   * 画面をロック解除する
   * @param  {String} id idに'lock'を削除
   */
  function unLockScreen(id) {
    'use strict';
    $('#' + id).remove();
  }
}